module.exports = __webpack_public_path__ + "img/menu_logo.eb7179d.png";